import moment from 'moment';
import { MediumGray } from '../Styles';

const marketEventDetail = (props) => (
  <div css={{ textAlign: 'center', marginTop: '0.8rem' }}>
    <div css={{ fontSize: '0.9rem' }}>
      <span css={{ fontWeight: 'bold' }}>
        { moment(props.market_event.start).utc().format('ddd, MMM D') }
      </span>
      <span>
        { ' ' }
        { moment(props.market_event.start_time).utc().format('h:mm a') }
        { '-' }
        { moment(props.market_event.end_time).utc().format('h:mm a') }
      </span>
      { (moment(props.market_event.order_window_start).isBefore(moment())
      && moment(props.market_event.order_window_close).isAfter(moment())) ? (
        <div className="text-sm text-green-medium">Ordering Open NOW:&nbsp;{ props.market_event.order_window_start && moment(props.market_event.order_window_start).format('ddd, MMM D') }
            &nbsp;-&nbsp;
          { props.market_event.order_window_start && moment(props.market_event.order_window_close).format('ddd, MMM D') }
        </div>
        ) : (
          <div css={{ color: '#CC6629', fontSize: '1rem' }}>Ordering Open:&nbsp;{ props.market_event.order_window_start && moment(props.market_event.order_window_start).format('ddd, MMM D') }
            &nbsp;-&nbsp;
            { props.market_event.order_window_start && moment(props.market_event.order_window_close).format('ddd, MMM D') }
          </div>
        )}
    </div>
    { props.market_event.description
      && (
      <div css={{ color: MediumGray, fontSize: '0.9rem' }}>
        { props.market_event.description }
      </div>
      )}
  </div>
);

export default marketEventDetail;
